namespace Gamification.Administration {
    export interface RolePermissionListResponse extends Serenity.ListResponse<string> {
    }
}

